module.exports = __webpack_public_path__ + "img/AKM.d567d90e.png";